import { Typography } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';

import { getPercentage } from 'core/utils';
import { PricingProfileRuleStructureType } from 'pricing/enums';
import { Color } from 'theme/enums';

export const ValueCell = ({ value, data }: ICellRendererParams) => {
  const isDiscount = data.structureType === PricingProfileRuleStructureType.DISCOUNT;
  const sign = isDiscount ? '-' : '+';

  return (
    <Typography color={isDiscount ? Color.DANGER : undefined}>
      {sign}
      {getPercentage(Number(value) / 100)}
    </Typography>
  );
};
